import { c as _c } from "react/compiler-runtime";
import { CircleAlert } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/src/components/shadcn/ui/alert";
export function WorkflowStepInformationNeeded(t0) {
  const $ = _c(4);
  const {
    note
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <CircleAlert className="size-4" />;
    t2 = <AlertTitle>Information needed</AlertTitle>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  const t3 = note || "Resolve the missing information before resuming this step.";
  let t4;
  if ($[2] !== t3) {
    t4 = <Alert className="border-warn/30 bg-warn/10">{t1}{t2}<AlertDescription className="whitespace-pre-wrap">{t3}</AlertDescription></Alert>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  return t4;
}